import { createLoadingStatusActionGroupWithResponse } from '~/shared/helpers/loading-status-helper';
import { RemoteConfig } from '@qvs/core';

const prefix = '[Remote Config]';

export const {
  load: loadRemoteConfig,
  success: loadRemoteConfigSuccess,
  failure: loadRemoteConfigFailure
} = createLoadingStatusActionGroupWithResponse<{ remoteConfig: RemoteConfig }>(prefix, 'remote config');
